<template>
  <aside class="menu">
    <ul class="menu-list">
      <li>
        <div class="field has-addons">
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="deployment_filter"
              :placeholder="$t('search deployment')"
            />
          </div>
          <div class="control">
            <div class="button" @click="refresh">
              <span class="icon">
                <i class="fa fa-refresh"></i>
              </span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div v-for="(group, idx) in grouped" :key="idx">
      <p class="menu-label">{{ group.name }}</p>
      <ul class="menu-list">
        <li
          v-for="(deployment, didx) in group.deployments"
          :key="didx"
          @click="$emit('select', deployment)"
        >
          <a>{{ deployment.name }} {{ deployment.version }}</a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { get, success_message, error_message } from "@/utils";
import { groupBy } from "lodash";

export default {
  name: "NgineManagerDeploymentList",
  components: {},
  data() {
    return {
      deployment_filter: "",
      deployments: [],
    };
  },
  computed: {
    grouped() {
      let v = this;
      let groups = groupBy(v.deployments, "process_id");
      return Object.keys(groups).map((key) => {
        return {
          name: key,
          deployments: groups[key],
        };
      });
    },
  },
  methods: {
    refresh() {
      let v = this;
      get("/ngine/deployment/list", {
        filter: v.deployment_filter,
      })
        .then((response) => {
          v.deployments = response;
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
